import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { fontSize, wh } from '../../../mixins';

const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

const GuaranteeBlock = styled.div`
  background: #FFFAF7;
  border: 3px solid #F58A3C;
  border-radius: 12px;
  padding: 40px 19px 19px;
  margin: ${({ $customMargin }) => $customMargin || '45px 0'};
  position: relative;

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: -33px;
    left: calc(50% - 30px);
  }

  &:before {
    background-color: #fff;
    ${wh('60px')};
    box-sizing: border-box;
    border-radius: 50%;
    border: inherit;
    border-top-color: transparent;
    border-right-color: transparent;
    transform: rotate(-45deg);
  }

  &:after {
    ${wh('60px')};
    background: url('../assets/guarantee-icon.svg') center no-repeat;
  }
`;

const GuaranteeTitle = styled.div`
  font-weight: 700;
  ${fontSize(24)};
  line-height: 31px;
  letter-spacing: -0.2px;
  color: #F58A3C;
  text-align: center;
  white-space: break-spaces;
  margin-bottom: 12px;
`;

const GuaranteeText = styled.div`
  ${fontSize(14)};
  line-height: 24px;
  color: #909090;
  text-align: ${textAlign};
`;

const Guarantee = ({ customMargin }) => {
  const { t } = useTranslation();

  const onTermsClick = e => {
    if (e.target.id !== 'terms-link') return;
    window.open('https://www.familo.net/en/assets/Terms_and_Conditions_Familonet_info.pdf');
  };

  return (
    <GuaranteeBlock $customMargin={customMargin}>
      <GuaranteeTitle>{t('guarantee_title')}</GuaranteeTitle>
      <GuaranteeText dangerouslySetInnerHTML={{__html: t('guarantee_text')}} onClick={e => onTermsClick(e)} />
    </GuaranteeBlock>
  )
};

export default Guarantee